<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><a class="hlink" href="#/toc">Table of Contents</a></p>
<p class="crt"><a class="hlink" href="#/ded">Dedication</a></p>
<p class="crt1"><a class="hlink" href="#/epi">Epigraph</a></p>
<p class="crt"><a class="hlink" href="#/p01">Teaching the Dog to Read</a></p>
<p class="crt1"><span class="hlink" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Jonathan Carroll</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7e50908a